import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authAxios } from "../config/config";
import IsLoadingHOC from "../common/IsLoadingHOC";
import { filterByDate } from "../helper/helper";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { setrefetch } from "../Redux/Reducers/authSlice";
import { IoIosArrowDown } from "react-icons/io";


const Sidebar = ({ setLoading }) => {

  const navigate = useNavigate();

  const [dropdownCategory, setDropdownCategory] = useState("");
  const [toggleCategory, setToggleCategory] = useState(false);
  const [currentid, setcurrentid] = useState("");
  const [List, setList] = useState([]);
  const [pressList, setpressList] = useState([]);
  const [blogList, setblogList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [dropdownMenuId, setDropdownMenuId] = useState(null);
  const dispatch  = useDispatch()
const refetch = useSelector(state=>state.auth.refetch)
console.log(refetch)
  const [itemCounts, setItemCounts] = useState({
    Today: { story: 4, press: 4, blog: 4 },
    Yesterday: { story: 4, press: 4, blog: 4 },
    Previous_7_Days: { story: 4, press: 4, blog: 4 },
    Previous_30_Days: { story: 4, press: 4, blog: 4 },
  });

  const [activeFilter, setActiveFilter] = useState("Today");
  const [activeCategory, setActiveCategory] = useState("story");

  const handleDropdownMenu = (filter) => {
    setDropdownCategory(dropdownCategory === filter ? "" : filter);
    setActiveFilter(filter);
    setActiveCategory("story");
    setItemCounts((prevCounts) => ({
      ...prevCounts,
      [filter]: { story: 4, press: 4, blog: 4 },
    }));
    getAllStory();
    getAllPress();
    getALlBlogs();
    setSearchTerm("");
};

  const handleToggleDropdownMenu = (id) => {
    setDropdownMenuId(dropdownMenuId === id ? null : id);
  };

  const truncateText = (text, maxLength) => {
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const handleRemove = () => {
    sessionStorage.removeItem("story_id");
    sessionStorage.removeItem("formType");
    setDropdownCategory("");
    setcurrentid("");
    setSearchTerm("");
  };

  const getAllStory = async () => {
    setLoading(true);
    await authAxios()
      .get(`/stories/get_multi_storie`)
      .then((response) => {
        setLoading(false);
        const resData = response?.data;
        setList(resData.data);
        dispatch(setrefetch(""))
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const getAllPress = async () => {
    setLoading(true);
    await authAxios()
      .get(`/press/getAllPressRelase`)
      .then((response) => {
        setLoading(false);
        const resData = response?.data;
        setpressList(resData.data);
        dispatch(setrefetch(""))
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const getALlBlogs = async () => {
    setLoading(true);
    await authAxios()
      .get(`/blog/getAllBlogRelase`)
      .then((response) => {
        setLoading(false);
        const resData = response?.data;
        setblogList(resData.data);
        dispatch(setrefetch(""))
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const handleOpenStory = (item) => {
    sessionStorage.setItem("story_id", item?._id);
    sessionStorage.setItem("formType", item?.formType);
    sessionStorage.removeItem("editable");
    setcurrentid(item._id);
    setDropdownMenuId(null)
  };

  useEffect(() => {
    if (refetch) {
      switch (refetch) {
        case 'story':
          getAllStory();
          break;
        case 'press':
          getAllPress();
          break;
        case 'blogs':
          getALlBlogs();
          break;
        default:
          break;
      }
    }
  }, [refetch]);

  const filteredData = filterByDate(List);
  const pressfilteredData = filterByDate(pressList);
  const blogfilteredData = filterByDate(blogList);

  const loadMoreItems = (category, dateRange) => {
    setItemCounts((prevCounts) => ({
      ...prevCounts,
      [dateRange]: {
        ...prevCounts[dateRange],
        [category]: prevCounts[dateRange][category] + 4,
      },
    }));
  };
  const handleEdit = (item,value) =>{
    sessionStorage.setItem("editable", true);
    sessionStorage.setItem("story_id", item?._id);
    sessionStorage.setItem("formType", item?.formType);

    setcurrentid(item._id);
    setDropdownMenuId(null)
    navigate(`/${value}`);
  }



  const handleDelete =async (id ,type)=> {

    let endpoint = ''; 
    let refreshFunction = null;
  switch (type) {
    case 'press':
      endpoint = '/press/deletePressRelease';
      refreshFunction = getAllPress;
      break;
    case 'blogs':
      endpoint = '/blog/deleteBlogRelease';
      refreshFunction = getALlBlogs;
      break;
    case 'story':
      endpoint = '/stories/deleteStoryRelease';
      refreshFunction = getAllStory;
      break;
    default:
      console.log('Invalid type');
      return;
  }
    setLoading(true);
    await authAxios()
    .post(endpoint, { "_id": id })
      .then((response) => {
        setLoading(false);
        
          refreshFunction();
        
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }
  return (
    <div
      className={`${
        toggleCategory ? "max-w-[104px]" : "max-w-[340px]"
      } p-6 border-r-[2px] border-r-[#E9F3FF] duration-300 w-full overflow-auto`}
    >
      <div className="flex flex-col justify-between gap-3 h-full">
        <div>
        <div className="logo-sidebar mb-[30px]">
            <Link to="/">
              {toggleCategory ? (
                <img src="./assets/images/final-logo.png" alt="Logo" />
              ) : (
                <img
                  src="./assets/images/final-logo.png"
                  className="h-20 ml-16"
                  alt="Logo"
                />
              )}
            </Link>
          </div>

          <div
            className="toggle-sidebar mb-[30px]"
            onClick={() => setToggleCategory(!toggleCategory)}
          >
            <div className="w-[50px] aspect-square rounded-[5px] bg-[#F1F1F1] flex items-center justify-center p-2 cursor-pointer ml-auto">
              <img
                src="./assets/images/toggle-icon.png"
                className={toggleCategory ? "rotate-180" : ""}
                alt="Toggle"
              />
            </div>
          </div>

          <div onClick={handleRemove} className="new-chat mb-[50px]">
            <Link to="/">
              <div className="bg-[#F1F1F1] text-[#2C2C2C] flex items-center min-h-[50px] rounded-[5px] px-[10px] py-[5px] cursor-pointer">
                <img src="./assets/images/plus-i.png" alt="New Chat" />
                {!toggleCategory && (
                  <p className="text-[#2C2C2C] font-semibold text-[14px]">
                   Generate New
                  </p>
                )}
              </div>
            </Link>
          </div>

          {!toggleCategory && (
            <div>
              <p className="text-[#2C2C2C] text-[14px] mb-2">History</p>

              <div className="category-dropdown mb-2">
                <div
                  className={`bg-[#FFE6D9] text-[#2C2C2C] flex items-center min-h-[50px] ${
                    dropdownCategory === "storycategory"
                      ? "rounded-b-[0px]"
                      : ""
                  } rounded-[5px] px-[15px] py-[5px] cursor-pointer justify-between`}
                  onClick={() => handleDropdownMenu("storycategory")}
                >
                  <p className="text-[#2C2C2C] font-semibold text-[14px]">
                    Story
                  </p>
                  <img src="./assets/images/down-arrow.png" alt="Arrow" />
                </div>

                {dropdownCategory === "storycategory" && (
                  <div className="bg-[#FFE6D9] rounded-b-[5px] px-[5px] py-[5px]">
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      placeholder="Search..."
                      className="w-full mb-2 p-1 border border-gray-300 rounded"
                    />

                    {Object.keys(filteredData)
                      .filter((key) => {
                        return filteredData[key].some((item) =>
                          item?.answers?.[0]?.Entrepreneurs_Full_Name.toLowerCase().includes(
                            searchTerm.toLowerCase()
                          )
                        );
                      })
                      .map((key) => (
                        <div key={key}>
                          {filteredData[key].some((item) =>
                            item?.answers?.[0]?.Entrepreneurs_Full_Name.toLowerCase().includes(
                              searchTerm.toLowerCase()
                            )
                          ) && (
                            <div className="min-h-[40px] flex items-center px-[15px]">
                              <p className="text-[12px] font-bold word-spacing-2">
                                {key.replaceAll("_", " ")}
                              </p>
                            </div>
                          )}

                          {filteredData[key]
                            .filter((item) =>
                              item?.answers?.[0]?.Entrepreneurs_Full_Name.toLowerCase().includes(
                                searchTerm.toLowerCase()
                              )
                            )
                            .slice(0, itemCounts[key].story)
                            .map((item) => (
                              <div className={`flex mt-1 relative items-center  justify-between pr-3 cursor-pointer  rounded-[5px] group ${
                                currentid === item?._id
                                  ? "bg-white text-black"
                                  : ""
                              }`}>
                            <Link
                              key={item?._id}
                              onClick={() => handleOpenStory(item)}
                              to={{
                                pathname: "/story",
                              }}
                              state={{ id: item?._id }}
                             className="min-h-[40px] items-center justify-center flex px-[15px] w-full"
                            >
                              <p className="text-[#2C2C2C] text-[14px] line-clamp-1 mr-2 flex-1">
                                {item?.answers?.[0]?.Entrepreneurs_Full_Name}
                              </p>
                            </Link>

                              <div className={` ${dropdownMenuId === item._id ? 'visible':'invisible'} group-hover:visible h-3 z-10 items-center justify-center flex`}   onClick={() => handleToggleDropdownMenu(item._id)}>
                                <img
                                  src="./assets/images/toggle-dot.png"
                                  alt="Dot"
                                />
                              </div>
                              {dropdownMenuId === item._id && (
                              <div className="absolute bg-white rounded-[5px] top-[100%] z-[999] w-full max-w-[100px] shadow-lg mt-1 right-0">
                                <ul className="flex flex-col">
                                  <li className="border-b border-b-[#ccc] py-2 px-3 flex items-center gap-1 text-[14px]" onClick={()=>handleEdit(item,"story")}>
                                    <MdModeEdit /> Edit
                                  </li>
                                  <li className="py-2 px-3 flex items-center gap-1 text-[14px] text-red-600" onClick={()=>handleDelete(item?._id, "story")}>
                                    <MdDeleteForever /> Delete
                                  </li>
                                </ul>
                              </div>
                            )}
                              </div>
                            ))}
                          {filteredData[key].length > itemCounts[key].story && (
                            <button
                              onClick={() => loadMoreItems("story", key)}
                              className="flex items-center justify-center gap-2 px-4 py-3 text-sm underline"
                            >
                              <IoIosArrowDown /> <span>See More</span>
                            </button>
                          )}
                        </div>
                      ))}
                    {Object.keys(filteredData).every((key) =>
                      filteredData[key].every(
                        (item) =>
                          !item?.answers?.[0]?.Entrepreneurs_Full_Name.toLowerCase().includes(
                            searchTerm.toLowerCase()
                          )
                      )
                    ) && (
                      <p className="text-[#2C2C2C] text-center">No Data Found</p>
                    )}
                  </div>
                )}
              </div>
              
              <div className="category-dropdown mb-2">
        <div
          className={`bg-[#FAF4CE] text-[#2C2C2C] flex items-center min-h-[50px] ${
            dropdownCategory === "blogcategory" ? "rounded-b-[0px]" : ""
          } rounded-[5px] px-[15px] py-[5px] cursor-pointer justify-between`}
          onClick={() => handleDropdownMenu("blogcategory")}
        >
          <p className="text-[#2C2C2C] font-semibold text-[14px]">Blogs</p>
          <img src="./assets/images/down-arrow.png" alt="Arrow" />
        </div>

        {dropdownCategory === "blogcategory" && (
          <div className="bg-[#FAF4CE] rounded-b-[5px] px-[5px] py-[5px]">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search..."
              className="w-full mb-2 p-1 border border-gray-300 rounded"
            />

            {Object.keys(blogfilteredData)
              .filter((key) => {
                return blogfilteredData[key].some((item) =>
                  item?.Title.toLowerCase().includes(searchTerm.toLowerCase())
                );
              })
              .map((key) => (
                <div key={key}>
                  {blogfilteredData[key].some((item) =>
                    item?.Title.toLowerCase().includes(searchTerm.toLowerCase())
                  ) && (
                    <div className="min-h-[40px] flex items-center px-[15px]">
                      <p className="text-[12px] font-bold word-spacing-2">
                        {key.replaceAll("_", " ")}
                      </p>
                    </div>
                     )}
                     {blogfilteredData[key]
                       .filter((item) =>
                         item?.Title.toLowerCase().includes(
                           searchTerm.toLowerCase()
                         )
                       ).slice(0, itemCounts[key].blog)
                       .map((item) => (
                         <div className={`flex mt-1 relative items-center  justify-between pr-3 cursor-pointer  rounded-[5px] group ${
                           currentid === item?._id
                                  ? "bg-white text-black"
                                  : ""
                              }`}>
                           <Link
                             key={item._id}
                             onClick={() => handleOpenStory(item)}
                             to={{
                               pathname: "/blogs",
                             }}
                             state={{ id: item._id }}
                             className='min-h-[40px] items-center justify-center flex px-[15px] w-full'
                           >
                             <p className="text-[#2C2C2C] text-[14px] line-clamp-1 mr-2 flex-1">
                               {item?.Title}
                             </p>
                           </Link>

                             <div className={` ${dropdownMenuId === item._id ? 'visible':'invisible'} group-hover:visible h-3 z-10 items-center justify-center flex`} onClick={() => handleToggleDropdownMenu(item._id)}>
                               <img
                                 src="./assets/images/toggle-dot.png"
                                 alt="Dot"
                               />
                             </div>

                           {dropdownMenuId === item._id && (
                              <div className="absolute bg-white rounded-[5px] top-[100%] z-[999] w-full max-w-[100px] shadow-lg mt-1 right-0">
                                <ul className="flex flex-col">
                                  <li className="border-b border-b-[#ccc] py-2 px-3 flex items-center gap-1 text-[14px]" onClick={()=>handleEdit(item,"blogs")}>
                                    <MdModeEdit /> Edit
                                  </li>
                                  <li className="py-2 px-3 flex items-center gap-1 text-[14px] text-red-600" onClick={()=>handleDelete(item?._id, "blogs")}>
                                    <MdDeleteForever/> Delete
                                  </li>
                                </ul>
                              </div>
                            )}
                              </div>
                          ))}
                            {blogfilteredData[key].length > itemCounts[key].blog && (
                    <button
                    onClick={() => loadMoreItems("blog", key)}
                    className="flex items-center justify-center gap-2 px-4 py-3 text-sm underline"
                    >
                      <IoIosArrowDown /> <span>See More</span>
                    </button>
                  )}
                       </div>
                     ))}

                    {Object.keys(blogfilteredData).every((key) =>
                      blogfilteredData[key].every(
                        (item) =>
                          !item?.Title.toLowerCase().includes(
                            searchTerm.toLowerCase()
                          )
                      )
                    ) && (
                      <p className="text-[#2C2C2C] text-center">
                        No Data Found
                      </p>
                    )}
                 </div>
                )}
              </div>

              <div className="category-dropdown mb-2">
                <div
                  className={`bg-[#E5EDFF] text-[#2C2C2C] flex items-center min-h-[50px] ${
                    dropdownCategory === "presscategory"
                      ? "rounded-b-[0px]"
                      : ""
                  } rounded-[5px] px-[15px] py-[5px] cursor-pointer justify-between`}
                  onClick={() => handleDropdownMenu("presscategory")}
                >
                  <p className="text-[#2C2C2C] font-semibold text-[14px]">
                    Press Release
                  </p>
                  <img src="./assets/images/down-arrow.png" alt="Arrow" />
                </div>

                {dropdownCategory === "presscategory" && (
                  <div className="bg-[#E5EDFF] rounded-b-[5px] px-[5px] py-[5px]">
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      placeholder="Search..."
                      className="w-full mb-2 p-1 border border-gray-300 rounded"
                    />
                    {Object.keys(pressfilteredData)
                      .filter((key) => {
                        return pressfilteredData[key].some((item) =>
                          item?.title
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase())
                        );
                      })
                      .map((key) => (
                        <div key={key}>
                          {pressfilteredData[key].some((item) =>
                            item?.title
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase())
                          ) && (
                          <div className="min-h-[40px] flex items-center px-[15px]">
                            <p className="text-[12px] font-bold word-spacing-2">
                              {key.replaceAll("_", " ")}
                            </p>
                          </div>
                          )}

                          {pressfilteredData[key]
                            .filter((item) =>
                              item?.title
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                            ).slice(0,itemCounts[key].press).map((item) => (
                              <div className={`flex mt-1 relative items-center  justify-between pr-3 cursor-pointer  rounded-[5px] group ${
                                currentid === item?._id
                                  ? "bg-white text-black"
                                  : ""
                              }`}>
                          
                            <Link
                              key={item._id}
                              onClick={() => handleOpenStory(item)}
                              to={{
                                pathname: "/press",
                              }}
                              state={{ id: item._id }}
                              className='min-h-[40px] items-center justify-center flex px-[15px] w-full'
                            >
                              <p className="text-[#2C2C2C] text-[14px] line-clamp-1 mr-2 flex-1">
                                {item?.title}
                              </p>
                           </Link>
                              <div className={` ${dropdownMenuId === item._id ? 'visible':'invisible'} group-hover:visible h-3 z-10 items-center justify-center flex`} onClick={() => handleToggleDropdownMenu(item._id)}>
                               <img
                                 src="./assets/images/toggle-dot.png"
                                 alt="Dot"
                               />
                             </div>

                           {dropdownMenuId === item._id && (
                              <div className="absolute bg-white rounded-[5px] top-[100%] z-[999] w-full max-w-[100px] shadow-lg mt-1 right-0">
                                <ul className="flex flex-col">
                                  <li className="border-b border-b-[#ccc] py-2 px-3 flex items-center gap-1 text-[14px]" onClick={()=>handleEdit(item,"press")}>
                                    <MdModeEdit /> Edit
                                  </li>
                                  <li className="py-2 px-3 flex items-center gap-1 text-[14px] text-red-600" onClick={()=>handleDelete(item?._id, "press")}>
                                    <MdDeleteForever /> Delete
                                  </li>
                                </ul>
                              </div>
                            )}
                              </div>
                          ))}
                           {pressfilteredData[key].length > itemCounts[key].press && (
                    <button
                    onClick={() => loadMoreItems("press", key)}
                    className="flex items-center justify-center gap-2 px-4 py-3 text-sm underline"
                    >
                      <IoIosArrowDown /> <span>See More</span>
                    </button>
                  )}

                        </div>
                      ))}
                    {Object.keys(pressfilteredData).every((key) =>
                      pressfilteredData[key].every(
                        (item) =>
                          !item?.title
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase())
                      )
                    ) && (
                      <p className="text-[#2C2C2C] text-center">
                        No Data Found
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IsLoadingHOC(Sidebar);
